var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDomainIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#E50B20",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0083 47.4357C40.5297 47.4314 47.4363 40.5223 47.4363 32.0001C47.4363 23.4752 40.5254 16.5645 32.0004 16.5645C23.4753 16.5645 16.5645 23.4752 16.5645 32.0001C16.5645 40.5223 23.471 47.4314 31.9924 47.4357L32.0004 47.4357L32.0083 47.4357ZM29.5537 18.9431C23.7309 20.0274 19.2438 24.9104 18.7613 30.9232H25.2262C25.5151 26.5927 27.0206 22.4418 29.5537 18.9431ZM34.4471 18.9431C36.9801 22.4418 38.4856 26.5927 38.7745 30.9232H45.2394C44.7569 24.9104 40.2698 20.0274 34.4471 18.9431ZM36.6154 30.9232C36.3019 26.6648 34.6904 22.6045 32.0004 19.2908C29.3103 22.6045 27.6989 26.6648 27.3853 30.9232H36.6154ZM27.3853 33.077H36.6154C36.3019 37.3354 34.6904 41.3957 32.0004 44.7094C29.3103 41.3957 27.6988 37.3354 27.3853 33.077ZM25.2262 33.077H18.7613C19.2438 39.0898 23.7309 43.9727 29.5536 45.057C27.0205 41.5583 25.5151 37.4075 25.2262 33.077ZM34.4471 45.057C36.9802 41.5583 38.4856 37.4075 38.7745 33.077H45.2394C44.7569 39.0898 40.2698 43.9727 34.4471 45.057Z",
    fill: "#E50B20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomainIc);
export default __webpack_public_path__ + "static/media/domain-ic.cdd0ea0eacf5d40b2a8b039a11274aa1.svg";
export { ForwardRef as ReactComponent };